import { makePieActionObjs } from 'shared/imports/pieActionGenerators'
import { prependAppName } from 'shared/imports/sharedHelperFunctions'

export const templateManagerAppName = '@@dlc-2-template-manager/'


const saveExistingTemplateObjs = makePieActionObjs('save', 'existingTemplate')
export const SAVE_EXISTING_TEMPLATE_PREFIX = "SAVE_EXISTINGTEMPLATE"

const saveNewTemplateObjs = makePieActionObjs('save', 'newTemplate')
const loadTemplatesObjs = makePieActionObjs('load', 'templates')
const archiveTemplateObjs = makePieActionObjs('archive', 'template')
const duplicateTemplateObjs = makePieActionObjs('duplicate', 'template')
const lockTemplateObjs = makePieActionObjs('lock', 'template')
const saveSafedSearchTemplateObjs = makePieActionObjs('saveSafedSearch', 'safedSearch')

export const saveExistingTemplateTypes = prependAppName(templateManagerAppName, saveExistingTemplateObjs.pieDict)
export const saveNewTemplateTypes = prependAppName(templateManagerAppName, saveNewTemplateObjs.pieDict)
export const loadTemplatesTypes = prependAppName(templateManagerAppName, loadTemplatesObjs.pieDict)
export const archiveTemplateTypes = prependAppName(templateManagerAppName, archiveTemplateObjs.pieDict)
export const duplicateTemplateTypes = prependAppName(templateManagerAppName, duplicateTemplateObjs.pieDict)
export const lockTemplateTypes = prependAppName(templateManagerAppName, lockTemplateObjs.pieDict)
export const saveSafedSearchTypes = prependAppName(templateManagerAppName, saveSafedSearchTemplateObjs.pieDict)

export const actionTypes = {
    SET_TEMPLATE_FIELD: `${templateManagerAppName}SET_TEMPLATE_FIELD`,
    SET_TEMPLATE_PERMISSIONS: `${templateManagerAppName}SET_TEMPLATE_PERMISSIONS`,
}

export default actionTypes
